import React, { useState } from 'react';
import { TFunction } from 'react-i18next';
import {
  ModalView,
  withTranslation,
  Stack,
  Button,
  Text,
} from '@piwikpro/ui-components';
import { withInject } from '@piwikpro/platform';
import { BillingService } from '../../BillingService';

interface InjectedProps {
  billingService: BillingService
  t: TFunction
}

export interface Props extends InjectedProps {
  onClose: () => void
}

export const RevokeCancelModal: React.FC<Props> = ({
  billingService,
  onClose,
  t,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <ModalView
      title={t('paddle.billing.revoke-cancel-modal.title')}
      actions={(
        <Stack spacing="narrow" horizontalAlignment="right" verticalAlignment="center">
          <Button
            disabled={isLoading}
            type="button"
            text={t('paddle.billing.revoke-cancel-modal.cancel-button')}
            appearance="default"
            onClick={onClose}
          />
          <Button
            pending={isLoading}
            onClick={async () => {
              try {
                setIsLoading(true);
                await billingService.revokeSubscriptionCancel();
                // eslint-disable-next-line no-empty
              } catch {} finally {
                await new Promise(resolve => setTimeout(resolve, 1000));
                await billingService.getCurrentSubscriptionTier();
                setIsLoading(false);
                onClose();
              }
            }}
            text={t('paddle.billing.revoke-cancel-modal.confirm-button')}
            appearance="primary"
          />
        </Stack>
      )}
      onClose={onClose}
    >
      <Stack vertical>
        <Stack.Item fill>
          <Text as="p">
            {t('paddle.billing.revoke-cancel-modal.text-confirmation')}
          </Text>
        </Stack.Item>
      </Stack>
    </ModalView>
  );
};

export default withInject<InjectedProps>({
  billingService: 'MarketingCrate.billingService',
})(withTranslation(['administration'])(RevokeCancelModal));
